// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"EditRedirect_pageContainer__2GgO-","heading":"EditRedirect_heading__2VBL0"};